import { render, staticRenderFns } from "./shiftRequest.vue?vue&type=template&id=670816dc&"
import script from "./shiftRequest.vue?vue&type=script&lang=js&"
export * from "./shiftRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports